import { apiClient } from './client';

export interface PanelNotification {
  id: number;
  client_id: number;
  kind: string;
  title: string;
  body: string;
  link: string; // in-panel path, or ''
  read: boolean;
  created_at: string;
}

export async function listNotifications(): Promise<PanelNotification[]> {
  const { data } = await apiClient.get<PanelNotification[]>('/api/notifications');
  return data;
}

export async function getUnreadCount(): Promise<number> {
  const { data } = await apiClient.get<{ unread: number }>('/api/notifications/unread');
  return data.unread;
}

export async function markAllRead(): Promise<void> {
  await apiClient.post('/api/notifications/read-all');
}

export async function deleteAllNotifications(): Promise<void> {
  await apiClient.delete('/api/notifications');
}

export interface NotificationTestResult {
  telegram: string; // 'ok', an error message, or '' when not configured
  email: string;
}

export async function sendTestNotification(): Promise<NotificationTestResult> {
  const { data } = await apiClient.post<NotificationTestResult>('/api/notifications/test');
  return data;
}
